import { get, replace, set, split } from 'lodash';
import { getInitials } from 'ui-utils';

import storage from '@lib/services/storageService';

import { LS_TH_LOG_DATA } from '../components/TelehealthSessionProvider/TelehealthSessionProvider';

// sanitises telehealth participant names removing undesired characters
export const formatParticipantName = (name?: string) => replace(split(name || '', ':')[0], /\s[\d]+$/gi, '');

export const saveTelehealthLog = (title: string, content?: any) => {
  const newContent = { ...storage.get(LS_TH_LOG_DATA), ...content };
  const participant = get(content, 'participant', '');
  const localParticipant = get(content, 'localParticipant', false);

  // converting participant names prevent patient app from logging patient PHI info
  if (participant) {
    set(newContent, 'participant', getInitials(participant));
  }

  if (localParticipant) {
    set(newContent, 'localParticipant', {
      ...localParticipant,
      identity: getInitials(formatParticipantName(localParticipant.identity)),
    });
  }

  // update log data and send the log to DD
  storage.set(LS_TH_LOG_DATA, newContent);
};
